import { getPriceVisibility } from 'src/app/dataAnalytics/utils/getPriceVisibility';
import type { Tealium } from 'src/types/appState';

export default (tealium: Tealium) => {
  const {
    autoClassifyCategoryChosen,
    autoClassifyCategorySuggested,
    cajaPayType,
    cajaWorkType,
    jobAdClassification,
    jobAdSubClassification,
    roleTitle,
    recommendedSalaryRange,
    salaryRangeSelected,
    priceVisibility,
  } = tealium;
  return {
    jobClassification: jobAdClassification,
    jobSubClassification: jobAdSubClassification,
    jobClassificationSelectedPosition: autoClassifyCategoryChosen,
    jobClassificationSuggestedCount: autoClassifyCategorySuggested,
    jobSalaryType: cajaPayType,
    jobWorkType: cajaWorkType,
    adSalaryRangeRecommended: recommendedSalaryRange,
    adSalaryRangeSelected: salaryRangeSelected,
    jobTitle: roleTitle,
    objectInteraction: 'shortlist-continue',
    isPriceHidden: getPriceVisibility(priceVisibility),
  };
};
